type AssetType = {
  label: string;
  supported: boolean;
};

const SUPPORTED_ASSET_TYPES: ReadonlyArray<AssetType> = [
  { label: "Stocks", supported: true },
  { label: "Options", supported: true },
  { label: "Multi-leg spreads", supported: true },
  { label: "Futures", supported: false },
  { label: "Crypto", supported: false },
];

const HOW_TO_EXPORT_STEPS: ReadonlyArray<string> = [
  "Open the thinkorswim desktop app and go to the Monitor tab.",
  "Open Account Statement and set the date range you want to import.",
  "Make sure the Cash Balance section is included so fees attach to your trades.",
  'Click the menu in the top-right of the statement and choose "Export to File" (CSV).',
  "Upload that CSV here.",
];

/**
 * Right-hand guidance panel for the import page (L0-U7): which ThinkOrSwim
 * asset types we support today, and a step-by-step "how to export your Account
 * Statement" walkthrough. This is the in-app export guidance ADR 0027 D2 calls
 * for, so a first-time importer never has to leave to figure out the export.
 */
export function ImportGuidance() {
  return (
    <aside
      data-testid="import-guidance"
      className="space-y-6 rounded-control border border-outline bg-surface-container p-5 shadow-sm"
    >
      <div className="space-y-2">
        <h2 className="text-sm font-semibold text-on-surface">ThinkOrSwim (Schwab)</h2>
        <p className="text-xs text-on-surface-variant">Supported asset types</p>
        <ul className="flex flex-wrap gap-2">
          {SUPPORTED_ASSET_TYPES.map((asset) => (
            <li
              key={asset.label}
              className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${
                asset.supported
                  ? "bg-success/15 text-success"
                  : "bg-surface-container-high text-on-surface-variant line-through"
              }`}
            >
              {asset.label}
            </li>
          ))}
        </ul>
      </div>

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-on-surface">
          How to export from ThinkOrSwim
        </h3>
        <ol className="list-decimal space-y-2 pl-5 text-sm text-on-surface-variant">
          {HOW_TO_EXPORT_STEPS.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      </div>
    </aside>
  );
}
